import { errorHandler } from '@/extra-functions/store.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
function intervalGetterCallback ({ suffix, repository, listName, loadingName, errorName }) {
  return function ({ date }) {
    return repository[suffix.toLowerCase()]({ date })
      .then(({ data }) => { this[listName] = data })
      .catch(error => { this[errorName] = errorHandler(error) })
      .then(() => { this[loadingName] = false })
  }
}

const snakeToCamel = (str) => str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))

const intervalGetters = (name, repository, cCallback = intervalGetterCallback, prefix = 'fetch', t = 1000, dateIntervals = ['Weekly', 'Monthly', 'Yearly']) => {
  const obj = {}
  const delay = searchDelay(t)
  dateIntervals.forEach(function (suffix) {
    const funcName = snakeToCamel(`${prefix}-${name}-${suffix.toLowerCase()}`)
    const listName = `${snakeToCamel(name)}List`
    const errorName = `${snakeToCamel(name)}Errors`
    const loadingName = `${snakeToCamel(name)}Loading`
    Object.assign(obj, { [funcName]: cCallback({ suffix, repository, listName, errorName, loadingName, delay }) })
  })
  return obj
}

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const apiVars = (identifier, attrs = {}) => {
  const obj = {}
  Object.keys(attrs).map(e => {
    Object.assign(obj, {
      [`${identifier}${capitalize(e)}`]: attrs[e],
    })
  })
  return {
    [`${identifier}List`]: [],
    [`${identifier}Loading`]: false,
    [`${identifier}Errors`]: [],
    ...obj,
  }
}

export {
  intervalGetters,
  apiVars,
  errorHandler,
}
